import { configureStore } from "@reduxjs/toolkit";
import employeesReducer from "../features/employeesSlice";
import legalEmployeesReducer from "../features/legalEmployeesSlice";
import branchesReducer from "../features/branchesSlice";
import authorizationReducer from "../features/authorizationSlice";
import responseReducer from "../features/responseSlice";


const store = configureStore({
  reducer: {
    employees: employeesReducer,
    legalEmployees: legalEmployeesReducer,
    branches: branchesReducer,
    authorization: authorizationReducer,
    transferResponse: responseReducer
  },
});

export default store;
